/*
 * File: cc-grid.component.ts                                                  *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';
import { CcGrid } from '../../../models/cc-grid.model';
import { Cell, Page } from '@nousmedis/cc-types';
import { PageTemplate } from '@nousmedis/cc-types';
import { PageService } from '../../../services/page.service';
import { GridLocked } from '../../../../catalog-cloud/interfaces/grid-locked.interface';
import { UserService } from '../../../../user/services/user.service';
import { User } from '@nousmedis/guard-types/dist/frontend';
import { ProductService } from '../../../services/product.service';
import { Subscription } from 'rxjs';
// import { UserModel } from '../../../user/models/user.model';
import { AuthModel } from '@nousmedis/nm-guard-auth';

@Component({
  selector: 'app-cc-grid',
  templateUrl: './cc-grid.component.html',
  styleUrls: ['./cc-grid.component.scss'],
})
export class CcGridComponent implements OnInit, OnDestroy {
  @Input() pageIndex: number;
  @Input() totalPages: number;
  @Input() baseGrids: PageTemplate[];
  @Input() idCatalog: string;
  @Input() idFascicle: string;
  @Input() idPage: string;
  @Input() isOdd: boolean;

  @Output() isLocked: EventEmitter<GridLocked> = new EventEmitter<GridLocked>();



  page: Page;
  currentPageTemplate: PageTemplate;
  cells: Cell[];
  backupCells: Cell[];
  backupPageTemplate: PageTemplate;


  //Cell sizes
  height: number = 0;
  width: number = 0;

  grid: CcGrid;

  lockedButtons: boolean = true;
  initialLockButtos: boolean = true;

  loading: boolean = true;
  logging: boolean = false;


  user: User;

  reloadSubs = new Subscription();
  changeSub = new Subscription();
  reloadGrid$ = new Subscription();


  constructor (
    private pageService: PageService,
    private productService: ProductService,
    private auth: AuthModel,
  ) {

  }
  ngOnDestroy(): void {
    this.reloadSubs.unsubscribe();
    this.changeSub.unsubscribe();
    this.reloadGrid$.unsubscribe();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getCellSize();
    }, 1);
  }

  ngOnInit(): void {
    this.user = this.auth.getCurrentUser();
    this.loadPageAndGrid();
    //Una vez cargada la pagina, se guardan los valores de las celdas a modo de backup
    if (this.page.cells.length > 0) this.backupCells = JSON.parse(JSON.stringify(this.page.cells));
    this.listenForChanges();
    this.loading = false;
  }

  getcurrentPageTemplate() {
    let baseIndex = 0;
    if (typeof this.page.pageTemplate === 'string') {
      baseIndex = this.baseGrids
        .map((b) => b.id)
        .indexOf(this.page.pageTemplate.toString());
      this.currentPageTemplate = this.baseGrids[baseIndex];
    } else {
      this.currentPageTemplate = this.page.pageTemplate as PageTemplate;
    }
  }

  loadPageAndGrid() {
    this.page = this.pageService.pages[this.pageIndex];
    if (this.page) {
      this.getcurrentPageTemplate();
      this.backupPageTemplate = this.currentPageTemplate;
      this.setGridFormat();
    }
  }

  listenForChanges() {
    this.reloadSubs = this.pageService.reloadGrid$.subscribe((data) => {
      this.loadPageAndGrid();
    });
    this.changeSub = this.pageService.pagesSubject.subscribe((data) => {
      this.loadPageAndGrid();
    });

    

  }

  setGridFormat() {
    this.loading = true;
    this.grid = new CcGrid(
      this.currentPageTemplate.rows,
      this.currentPageTemplate.columns
    );
    this.grid.setGrid(this.page.cells);
    this.loading = false;
  }

  async saveGridFormat(saved: boolean) {

    if (!saved) {
      this.pageService.rollBackPage(
        this.pageIndex,
        this.backupPageTemplate.id,
        this.backupCells
      );
    } else {
      this.page.cells.forEach((cell) => {
        if (cell.product && !cell.visible)
          this.productService.removeProduct$.next(cell.product.id);
      });
      this.page = this.pageService.removeProductsOnHiddenCells(this.page);
      this.pageService.savePages().subscribe(async (data) => {
        console.log('Page saved',this.page);
        this.page = data.pages[this.pageIndex];
        this.pageService.pages[this.pageIndex] = data.pages[this.pageIndex];
        this.loadPageAndGrid();
      });

      // this.loadPageAndGrid();
    }
  }

  changePageFormat(format: PageTemplate) {
    this.pageService.setGrid(this.pageIndex, format, this.user.id);
    this.currentPageTemplate = format;
    this.page = this.pageService.pages[this.pageIndex];
    this.setGridFormat();
  }

  lock(locked: boolean) {
    this.lockedButtons = locked;
    let emitLock: GridLocked = {
      index: this.pageIndex,
      locked: this.lockedButtons,
    };
    this.isLocked.emit(emitLock);
  }

  getCellSize() {
    this.height =
      document.getElementById('page-' + this.idPage).offsetHeight /
      this.grid.rows;

    this.width =
      document.getElementById('page-' + this.idPage).offsetWidth /
      this.grid.columns;
  }

  refreshCell() {
    this.page.cells = this.grid.cells.map(c => c.data);
  }
}
